// extracted by mini-css-extract-plugin
export default {"toggleCheckbox":"styles_toggleCheckbox__0IIGi","disabled":"styles_disabled__QRi31"};